import React from 'react'
import { Box, Grid, Typography, Card, CardMedia, Divider } from '@mui/material'
import ServicesHeader from './servicesHeader'
import './services.css'

import deckingExample1 from '../_content/decking1.webp'
import deckingExample2 from '../_content/decking2.webp'
import deckingExample3 from '../_content/decking3.webp'
import deckingExample4 from '../_content/decking4.webp'
import deckingExample5 from '../_content/decking.webp'
import deckingExample6 from '../_content/decking5.webp'

const DeckingServices = () => {
  return (
    <>
      <ServicesHeader
        background={deckingExample1}
        text="Decking Services"
      />

      {/* TOP STRIP */}
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />
      <Box className="top-strip">
        <Typography className="top-strip-text">
          Transform your garden with bespoke decking designed for relaxation and outdoor living, covering Brentwood and Essex.
        </Typography>
      </Box>
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />

      {/* WHITE SECTION */}
      <Box className="section-wrapper">
        <Box className="section-inner">
          <Box className="section-content">

            <Typography className="section-heading" variant="h5">
              Stylish decking built for comfort and durability
            </Typography>

            <Typography className="section-subtext">
              Whether you want to create a seating area, entertain guests or upgrade your outdoor space, we design and install decking that looks great and lasts.
            </Typography>

            <Box className="section-divider" />

            <Grid container spacing={3} alignItems="stretch">
              {[
                {
                  title: 'Bespoke Designs',
                  text: 'We design decking tailored to your garden, creating a layout that works for your space, lifestyle and requirements.',
                },
                {
                  title: 'Quality Materials',
                  text: 'We use durable, high-quality materials to ensure your decking remains strong, safe and visually appealing.',
                },
                {
                  title: 'Expert Installation',
                  text: 'Our team delivers precise, professional installation for a clean finish and long-lasting structure.',
                },
              ].map((item, i) => (
                <Grid item xs={12} md={4} key={i} sx={{ display: 'flex' }}>
                  <Box className="service-card">
                    <Box>
                      <Typography className="card-title">{item.title}</Typography>
                      <Typography className="card-text">{item.text}</Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>

          </Box>
        </Box>
      </Box>

      {/* IMAGE SECTION */}
      <Box className="image-section">
        <Typography className="image-title" variant="h5">
          Recent Projects
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {[deckingExample2, deckingExample6, deckingExample4, deckingExample1, deckingExample3, deckingExample5].map((img, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Card className="image-card">
                <CardMedia
                  component="img"
                  image={img}
                  alt={`Decking example ${i + 1}`}
                  className="image-media"
                />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}

export default DeckingServices